import * as React from 'react'
import { ReactElement, useMemo } from 'react'
import NoteList, { NoteListProps } from '../../components/List/Note/NoteList'
import { useTranslation } from 'react-i18next'
import useEntity from '../../hooks/useEntity'
import { Spinner, SpinnerSize } from '@fluentui/react'
import { NoteOverviewDto } from '../../config/noteConfig'

type Props = { baseUrl: string } & NoteListProps

export default function NoteOverview(props: Props): ReactElement {
    const { t: translate } = useTranslation()

    const [lazyItems, , , reloadLazyItems] = useEntity<NoteOverviewDto[]>(() => ({ url: props.baseUrl }), props.notes === null ? false : null)
    const isItemsLoaded = useMemo(() => props.notes !== null || lazyItems.loaded, [props.notes, lazyItems])

    // Reload (instead of reset) keeps the current items visible while refreshing, so the overview
    // doesn't flash back to a spinner after a note is saved or deleted.
    const lazyProps: Props = useMemo<Props>(() => ({ ...props, notes: lazyItems, reset: reloadLazyItems }), [lazyItems, props, reloadLazyItems])

    if (!isItemsLoaded) {
        return <Spinner label={translate('base.loading')} size={SpinnerSize.small} labelPosition="right" />
    }
    if (props.notes === null) {
        return <NoteList {...lazyProps} />
    }

    return <NoteList {...props} />
}
